// libs
import React from 'react';

// components
import SizeGuide from 'shared/layouts/SizeGuide';
import { OverlaySheetContext } from 'shared/components/OverlaySheet';

// styles
import { OverlaySheet, Container } from './styles';

// constants
import { SHEET_TRANSITION } from 'shared/components/OverlaySheet/constants';

function SizeGuideBottomSheet({ onClose }: { onClose: () => void }) {
  return (
    <OverlaySheet
      onHide={onClose}
      transitionFrom={SHEET_TRANSITION.BOTTOM}
      disableNav
      navKey="sizeGuideMobile"
      hideOnOverlayClick={true}
      allowScroll={false}
    >
      <OverlaySheetContext.Consumer>
        {({ doHide }) => (
          <Container>
            <SizeGuide onClose={doHide} />
          </Container>
        )}
      </OverlaySheetContext.Consumer>
    </OverlaySheet>
  );
}

export default SizeGuideBottomSheet;
